export default "__VITE_ASSET__BjhvzF0k__"